/**
 * Recap auto-draft times: stored as 24-hour "HH:MM" Central wall-clock time
 * (America/Chicago, CDT or CST as the date falls), shown on a 12-hour clock.
 */

export type Period = 'AM' | 'PM'

export interface TwelveHour {
  hour: number // 1-12
  minute: number // 0-59
  period: Period
}

/** "19:00" -> { hour: 7, minute: 0, period: 'PM' } */
export const toTwelveHour = (hhmm: string): TwelveHour => {
  const [h, m] = hhmm.split(':').map(Number)
  return { hour: h % 12 || 12, minute: m, period: h < 12 ? 'AM' : 'PM' }
}

/** { hour: 7, minute: 0, period: 'PM' } -> "19:00" */
export const toTwentyFourHour = ({ hour, minute, period }: TwelveHour): string => {
  const h = (hour % 12) + (period === 'PM' ? 12 : 0)
  return `${String(h).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

/** "19:00" -> "7:00 PM CT" */
export const formatCentralTime = (hhmm: string): string => {
  const { hour, minute, period } = toTwelveHour(hhmm)
  return `${hour}:${String(minute).padStart(2, '0')} ${period} CT`
}
